import * as z from "zod";
import type {
  PortalSettingsPatch,
  ReturnsPortalSettingsSource,
} from "./portal-settings-source";

export const shippingOptionsSettingsShape = {
  shippingOptions: z.object({
    deductLabelFromRefund: z.boolean(),
    deductLabelFromCredit: z.boolean(),
    deductLabelFromExchange: z.boolean(),
  }),
};

export type ShippingOptionsSettings = z.infer<
  z.ZodObject<typeof shippingOptionsSettingsShape>
>;

export function shippingOptionsSettingsFromTeam({
  settings,
}: ReturnsPortalSettingsSource): ShippingOptionsSettings {
  return {
    shippingOptions: {
      deductLabelFromRefund: !!settings.deductLabelFromRefund,
      deductLabelFromCredit: !!settings.deductLabelFromCredit,
      deductLabelFromExchange: !!settings.deductLabelFromExchange,
    },
  };
}

export function shippingOptionsTeamPatch({
  shippingOptions,
}: ShippingOptionsSettings): PortalSettingsPatch {
  return {
    set: {
      deductLabelFromRefund: shippingOptions.deductLabelFromRefund,
      deductLabelFromCredit: shippingOptions.deductLabelFromCredit,
      deductLabelFromExchange: shippingOptions.deductLabelFromExchange,
    },
    unset: [],
  };
}
